import { jsx, jsxs } from 'react/jsx-runtime';
import cns from '../../../../node_modules/classnames/index.js';
import '../common.js';
import EllipsisText from '../../../EllipsisText/EllipsisText.js';
import { EmphasisLM } from '../../../types.js';

/**
 * Legend da inserire nel fieldset.
*/
function FormFieldFrameLegend({ title = undefined, titleIcon = undefined, emphasis, }) {
    if (emphasis === EmphasisLM.LOW) {
        return jsx("legend", { className: "v2-form-field-frame__legend v2-form-field-frame__legend--none" });
    }
    const legendClass = cns('v2-form-field-frame__legend', {
        'v2-form-field-frame__legend--none': !titleIcon && !title,
        'v2-form-field-frame__legend--with-title-icon': !!titleIcon,
    });
    return (jsxs("legend", { className: legendClass, children: [jsxs(EllipsisText, { top: false, children: [' ', title || '  ', ' '] }), titleIcon && jsx("div", { className: "v2-form-field-frame__title-icon", children: titleIcon })] }));
}

export { FormFieldFrameLegend as default };
